import { render } from "./VPage.vue?vue&type=template&id=b1e882bc&ts=true"
import script from "./VPage.vue?vue&type=script&lang=ts"
export * from "./VPage.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__